import { render, staticRenderFns } from "./RetailerSkus.vue?vue&type=template&id=f44a960a&"
import script from "./RetailerSkus.vue?vue&type=script&lang=js&"
export * from "./RetailerSkus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports